"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeEpcResponse$ = exports.PostcodeEpcResponse$outboundSchema = exports.PostcodeEpcResponse$inboundSchema = void 0;
exports.postcodeEpcResponseToJSON = postcodeEpcResponseToJSON;
exports.postcodeEpcResponseFromJSON = postcodeEpcResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const postcodeepcwrapper_js_1 = require("./postcodeepcwrapper.js");
/** @internal */
exports.PostcodeEpcResponse$inboundSchema = z.object({
    data: z.array(postcodeepcwrapper_js_1.PostcodeEpcWrapper$inboundSchema),
});
/** @internal */
exports.PostcodeEpcResponse$outboundSchema = z.object({
    data: z.array(postcodeepcwrapper_js_1.PostcodeEpcWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeEpcResponse$;
(function (PostcodeEpcResponse$) {
    /** @deprecated use `PostcodeEpcResponse$inboundSchema` instead. */
    PostcodeEpcResponse$.inboundSchema = exports.PostcodeEpcResponse$inboundSchema;
    /** @deprecated use `PostcodeEpcResponse$outboundSchema` instead. */
    PostcodeEpcResponse$.outboundSchema = exports.PostcodeEpcResponse$outboundSchema;
})(PostcodeEpcResponse$ || (exports.PostcodeEpcResponse$ = PostcodeEpcResponse$ = {}));
function postcodeEpcResponseToJSON(postcodeEpcResponse) {
    return JSON.stringify(exports.PostcodeEpcResponse$outboundSchema.parse(postcodeEpcResponse));
}
function postcodeEpcResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeEpcResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeEpcResponse' from JSON`);
}
//# sourceMappingURL=postcodeepcresponse.js.map